import React from "react";
import { Routes, Route } from "react-router-dom";
import "./CSS/Global.css";
import Header from "./Components/Header";
import Home from "./Components/Home";
import AboutPage from "./Components/AboutPage";
import Footer from "./Components/Footer";
import ServicePage from "./Components/ServicePage";
import ContactPage from "./Components/ContactPage";
import PersonalLoanInfo from "./Components/PersonalLoanInfor";
import BusinessLoanInfo from "./Components/BusinessLoanInfo";
import HomeLoanInfo from "./Components/HomeLoanInfo";
import MortgageLoanInfo from "./Components/MortgageLoanInfo";
import AutomobileLoanInfo from "./Components/AutoMobileLoanInfo";
import AgriculturalLoanInfo from "./Components/AgricultureLoanInfo";
import EducationLoanInfo from "./Components/EducationLoanInfo";
import GoldLoanInfo from "./Components/GoldLoanInfo";
import LoanEMICalculator from "./Components/LoanEMICalulator";
import HomeMainSection from "./Components/HomeMainSection";
import ApplyNow from "./Components/ApplyNow";
import ScrollToTop from "./Components/ScrollToTop";
import { ToastContainer } from "react-toastify";
import ChannelPartners from "./Components/ChannelPartner";
import CarLoanInfo from "./Components/CarLoanInfo";
import WhoWeAre from "./Components/WhoWeAre";
import LoanOfferings from "./Components/LoanOfferings";
import MumbaiAdvantage from "./Components/MumbaiAdvantage";
import ClientSuccessStories from "./Components/ClientSuccessStories";
import MakePartner from "./Components/MakePartner";
import ConstructionFundingInfo from "./Components/ConstructionFundingInfo";
import PropertySearchInfo from "./Components/PropertySearchInfo";
import CommercialVehicleLoansInfo from "./Components/CommercialVehicleLoansInfo";
import GeneralInsuranceInfo from "./Components/GeneralInsuranceInfo";
import LifeInsuranceInfo from "./Components/LifeInsuranceInfo";
import MutualFundsInfo from "./Components/MutualFundsInfo";
import ReDevelopmentConsultancyInfo from "./Components/ReDevelopmentConsultancyInfo";
import SoleSellingAgentInfo from "./Components/SoleSellingAgentInfo";
import IndustrialLoanInfo from "./Components/IndustrialLoanInfo";
import CommercialLoanInfo from "./Components/CommercialLoanInfo";
import PropertyExhibitionInfo from "./Components/PropertyExhibitionInfo";
import PropertyInsuranceInfo from "./Components/PropertyInsuranceInfo";
import HealthInsuranceInfo from "./Components/HealthInsuranceInfo";
import VehicleInsuranceInfo from "./Components/VehicleInsuranceInfo";
import LoanAgainstSecuritiesInfo from "./Components/LoanAgainstSecuritiesInfo";
import BalanceTransferInfo from "./Components/BalanceTransferInfo";
import WhatsAppButton from "./Components/WhatsAppButton";

const App = () => {
  return (
    <>
      <Header />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-Magnify-Advisory" element={<AboutPage />} />
        <Route path="/loan-services-india" element={<ServicePage />} />
        <Route path="/contact-loan-experts" element={<ContactPage />} />
        <Route path="/personal-loan-mumbai-thane-palghar-maharashtra-delhi-india" element={<PersonalLoanInfo />} />
        <Route path="/business-loan-mumbai-thane-palghar-maharashtra-delhi-india" element={<BusinessLoanInfo />} />
        <Route path="/home-loan-mumbai-thane-palghar-maharashtra-delhi-india" element={<HomeLoanInfo />} />
        <Route path="/mortgage-loan-mumbai-thane-palghar-maharashtra-delhi-india" element={<MortgageLoanInfo />} />
        <Route path="/education-loan-mumbai-thane-palghar-maharashtra-delhi-india" element={<EducationLoanInfo />} />
        <Route path="/gold-loan-mumbai-thane-palghar-maharashtra-delhi-india" element={<GoldLoanInfo />} />
        <Route path="/car-loan-mumbai-thane-palghar-maharashtra-delhi-india" element={<CarLoanInfo />} />
        <Route path="/emi-calculator-loan" element={<LoanEMICalculator />} />
        <Route path="/home-updates" element={<HomeMainSection />} />
        <Route path="/apply-loan-online" element={<ApplyNow />} />
        <Route path="/channel-partner" element={<ChannelPartners />} />
        <Route path="/who-we-are" element={<WhoWeAre />} />
        <Route path="/loan-offerings" element={<LoanOfferings />} />
        <Route path="/client-success-stories" element={<ClientSuccessStories />} />
        <Route path="/make-partner" element={<MakePartner />} />
        <Route path="/construction-funding-mumbai-thane-palghar-maharashtra-delhi-india" element={<ConstructionFundingInfo />} />
        <Route path="/property-search-mumbai-thane-palghar-maharashtra-delhi-india" element={<PropertySearchInfo />} />
        <Route path="/commercial-vehicle-loans-mumbai-thane-palghar-maharashtra-delhi-india" element={<CommercialVehicleLoansInfo />} />
        <Route path="/general-insurance-mumbai-thane-palghar-maharashtra-delhi-india" element={<GeneralInsuranceInfo />} />
        <Route path="/life-insurance-mumbai-thane-palghar-maharashtra-delhi-india" element={<LifeInsuranceInfo />} />
        <Route path="/mutual-funds-mumbai-thane-palghar-maharashtra-delhi-india" element={<MutualFundsInfo />} />
        <Route path="/redevelopment-consultancy-mumbai-thane-palghar-maharashtra-delhi-india" element={<ReDevelopmentConsultancyInfo />} />
        <Route path="/sole-selling-agent-entire-project-mumbai-thane-palghar-maharashtra-delhi-india" element={<SoleSellingAgentInfo />} />
        <Route path="/industrial-loan-mumbai-thane-palghar-maharashtra-delhi-india" element={<IndustrialLoanInfo />} />
        <Route path="/commercial-loan-mumbai-thane-palghar-maharashtra-delhi-india" element={<CommercialLoanInfo />} />
        <Route path="/property-exhibition-mumbai-thane-palghar-maharashtra-delhi-india" element={<PropertyExhibitionInfo />} />
        <Route path="/property-insurance-mumbai-thane-palghar-maharashtra-delhi-india" element={<PropertyInsuranceInfo />} />
        <Route path="/health-insurance-mumbai-thane-palghar-maharashtra-delhi-india" element={<HealthInsuranceInfo />} />
        <Route path="/vehicle-insurance-mumbai-thane-palghar-maharashtra-delhi-india" element={<VehicleInsuranceInfo />} />
        <Route path="/loan-against-securities-mumbai-thane-palghar-maharashtra-delhi-india" element={<LoanAgainstSecuritiesInfo />} />
        <Route path="/balance-transfer-mumbai-thane-palghar-maharashtra-delhi-india" element={<BalanceTransferInfo />} />
      </Routes>
      <Footer />
      <WhatsAppButton />
      <ToastContainer/>
    </>
  );
};

export default App;
